<template>
  <div id="app">
    <div id="nav">
      <nav-header @changePath="changePath"
                  @changeColor="changeColor"></nav-header>
    </div>
    <router-view id="container"
                 :class="isDark?'dark':''" />
  </div>
</template>
<script>
import navHeader from "./components/navHeader.vue";

export default {
  components: {
    navHeader,
  },
  data() {
    return {
      isDark: false,
    };
  },
  watch: {},

  methods: {
    changePath(key) {
      this.$router.push({ path: "/" + key });
    },
    changeColor(isDark) {
      this.isDark = isDark;
    },
  },
};
</script>

<style lang="scss">
/* 灰度 */
/* html {
  filter: grayscale(1);
} */
/* 黑色 */
/* html {
  filter: invert(1) hue-rotate(180deg);
} */
/* 所有内容除了图片及视屏反相颜色 */
.dark:not(.example-pane) {
  filter: invert(1) hue-rotate(180deg);
  img,
  video,
  #example-page {
    filter: invert(1) hue-rotate(180deg);
  }
}

html,
body,
#app {
  padding: 0;
  margin: 0;
  min-width: 855px;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  position: sticky;
  z-index: 9;
  top: 0;
  height: 60px;
  width: 100%;
  line-height: 60px;
  background-color: white;
}
#container {
  background-color: #f0f0f0;
  transition: all 300ms;
  height: calc(100vh - 60px);
  position: sticky;
  z-index: 1;
}
</style>
